import {
  OBTENER_MENUS,
  CREAR_NUEVO_MENU,
  PREPARAR_NUEVO_MENU,
  LIMPIAR_ESTADO_MENUS,
} from "../types";

// eslint-disable-next-line
export default (state, action) => {
  switch (action.type) {
    case OBTENER_MENUS:
      return {
        ...state,
        menus: action.payload,
      };

    case CREAR_NUEVO_MENU:
      return {
        ...state,
        creando: true,
      };

    case PREPARAR_NUEVO_MENU:
      return {
        ...state,
        creando: false,
      };

    case LIMPIAR_ESTADO_MENUS:
      return {
        ...state,
        menus: [],
        menu: null,
        creando: false,
      };

    default:
      return state;
  }
};
